      <button
        *ngFor="let item of items; let i=index"
        class="btn-switch"
        [class.active]="item.applied"
        [class.single-button]="items.length < 2"
        (click)="selectSwitchItem(i)"
      >
        {{ item.text }}
      </button>
